import type { PublicUserResponse } from '@contracts/order/PublicOrderResponse';
import { MobileContactCard } from '@src/authentication/MobileContactCard';
import { LogoAndBrand } from '@src/common/components/brand/LogoAndBrand';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { useTranslation } from 'react-i18next';

export const PublicPortalExpiredLink = ({
  assignee,
}: {
  assignee?: PublicUserResponse;
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={1.5}
      sx={{ width: '100%', height: '100vh', px: 3, textAlign: 'center' }}
    >
      <LogoAndBrand width={120} height={80} />
      <Typography variant="h5">
        {t('publicPortal.error.expired.title')}
      </Typography>
      <Typography variant="body1">
        {t('publicPortal.error.expired.message')}
      </Typography>
      <Stack sx={{ mt: 3 }}>
        <MobileContactCard
          id={assignee?.id}
          name={assignee?.name}
          email={assignee?.email}
          extension={assignee?.extension}
        />
      </Stack>
    </Stack>
  );
};
